import { tsv } from "@faire/slate/lib/tsv";
import React from "react";

type IProps = React.HTMLAttributes<HTMLElement>;

export const AccordionItemSummary = ({
  className,
  children,
  ...props
}: IProps) => {
  return (
    <summary className={summaryStyle.cls({ className })} {...props}>
      {children}
    </summary>
  );
};

const summaryStyle = tsv({
  base: "fs-accordion__summary interactive focusable",
});
